import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { submitResponse } from '../methods';
import { SubmitResponseRequest, SubmitResponseResponse } from '../types';

export const useSubmitResponse = (): UseMutationResult<
  SubmitResponseResponse,
  unknown,
  SubmitResponseRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(submitResponse, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultation] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultations] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getCaseDetails] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getResponses] });
    },
  });
};
